/**
 * @file error-list.component.tsx
 * @description Компонент списка ошибок для Task Manager приложения, который обеспечивает централизованное отображение сообщений об ошибках через интерфейс SnackBar. Реализован как forwardRef компонент с императивным API для управления списком ошибок извне, поддерживает начальные элементы и предоставляет метод setItems для обновления списка ошибок. Используется для уведомления пользователей о проблемах в работе приложения.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-16
 * @dependencies ['react', '@src/components/ui/indicators/snack-bar', '@src/types']
 * @related-files ['src/components/ui/snack-bar', 'src/types/error-message.ts', 'src/utils/error-helper.ts']
 * @todo Переименовать интерфейс ErrorListHandle для соответствия naming conventions
 */

import { forwardRef, useImperativeHandle, useState } from 'react';
import { SnackBar } from '@src/components/ui/indicators/snack-bar';
import { TErrorMessage } from '@src/types';

/**
 * Интерфейс для императивного управления списком ошибок через ref
 * TODO: переименовать на IErrorListHandle для соответствия naming conventions
 */
export interface ErrorListHandle {
    /** Метод для установки нового списка ошибок */
    setItems: (newItemsList: TErrorMessage[]) => void;
}

/**
 * Props для компонента списка ошибок
 */
interface IErrorListProps {
    /** Начальный список ошибок для отображения */
    initialItems?: TErrorMessage[];
}

export const ErrorList = forwardRef<ErrorListHandle, IErrorListProps>(({ initialItems = [] }, ref) => {
    const [items, setItems] = useState<TErrorMessage[]>(initialItems);

    useImperativeHandle(
        ref,
        () => ({
            setItems: (newItemsList: TErrorMessage[]) => {
                setItems(newItemsList);
            }
        }),
        []
    );

    return <SnackBar items={items} setItems={setItems} clearItems={() => setItems([])} />;
});